import { z } from 'zod';
export const healthStatusSchema = z.enum(['ok', 'degraded']);
export const probeResultSchema = z.object({
    name: z.string().min(1),
    healthy: z.boolean(),
    detail: z.string().optional(),
});
export const healthResponseSchema = z.object({
    status: healthStatusSchema,
    version: z.string().min(1),
    uptimeSeconds: z.number().nonnegative(),
    checkedAt: z.iso.datetime(),
    probes: z.array(probeResultSchema),
});
//# sourceMappingURL=health.js.map